
import React from "react";

const GoogleIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8 10.2083C18.8 9.55834 18.7417 8.93334 18.6333 8.33334H10V11.8833H14.9333C14.7167 13.025 14.0667 13.9917 13.0917 14.6417V16.95H16.0667C17.8 15.35 18.8 13 18.8 10.2083Z"
        fill="#4285F4"
      />
      <path
        d="M9.99998 19.1667C12.475 19.1667 14.55 18.35 16.0667 16.95L13.0917 14.6417C12.275 15.1917 11.2333 15.525 9.99998 15.525C7.61665 15.525 5.59165 13.9167 4.86665 11.75H1.81665V14.1167C3.32498 17.1083 6.41665 19.1667 9.99998 19.1667Z"
        fill="#34A853"
      />
      <path
        d="M4.86665 11.7417C4.68331 11.1917 4.57498 10.6083 4.57498 10C4.57498 9.39166 4.68331 8.80833 4.86665 8.25833V5.89166H1.81665C1.19165 7.125 0.833313 8.51666 0.833313 10C0.833313 11.4833 1.19165 12.875 1.81665 14.1083L4.19165 12.2583L4.86665 11.7417Z"
        fill="#FBBC05"
      />
      <path
        d="M9.99998 4.48334C11.35 4.48334 12.55 4.95001 13.5083 5.85001L16.1333 3.22501C14.5417 1.74168 12.475 0.833344 9.99998 0.833344C6.41665 0.833344 3.32498 2.89168 1.81665 5.89168L4.86665 8.25834C5.59165 6.09168 7.61665 4.48334 9.99998 4.48334Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default GoogleIcon;
